export default __webpack_public_path__ + "static/media/spinner.fda3af02.gif";